import { a } from './chunk-IMSWER4T.js';

var n=(t=>(t.BRANDS="brands",t.RETAILERS="retailers",t.MODULES="modules",t))(n||{});var i=class{_client=a.instance;async getIncompleteProductsForAuditor(r,e,t,m){return await(await this._client.get(`${r}/${e}/incomplete-products?page=${t}&limit=${m}`)).data}async getIncompleteProductDetailsForAuditor(r,e,t){return await(await this._client.get(`${r}/${e}/incomplete-products/${t}`)).data}};

export { n as a, i as b };
//# sourceMappingURL=chunk-JBRCJEIM.js.map
//# sourceMappingURL=chunk-JBRCJEIM.js.map